import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import AutoLink from '@/components/AutoLink';
import AdditionalCostsIcon from '@/svg-icons/AdditionalCosts';

const AdditionalCostsSection = ({ additionalCosts }) => {
  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <AdditionalCostsIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="additionalCosts" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="w-full mb-[1vw]">
          <div className="font-bold">
            <FormattedMessage id="price" />
          </div>
          <span data-cy="additional-costs-price">{additionalCosts?.price} créditos</span>
        </div>

        <div className="w-full">
          <div className="font-bold">
            <FormattedMessage id="description" />
          </div>
          {additionalCosts?.description && (
            <div data-cy="additional-costs-description">
              <AutoLink text={additionalCosts?.description} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

AdditionalCostsSection.propTypes = {
  additionalCosts: PropTypes.object.isRequired,
};

export default AdditionalCostsSection;
